import { render, staticRenderFns } from "./AttactmentTab.vue?vue&type=template&id=cb34ccee&scoped=true"
import script from "./AttactmentTab.vue?vue&type=script&lang=js"
export * from "./AttactmentTab.vue?vue&type=script&lang=js"
import style0 from "./AttactmentTab.vue?vue&type=style&index=0&id=cb34ccee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb34ccee",
  null
  
)

export default component.exports